export function getElementWidth(selector) {
  const element = document.querySelector(selector);
  return element.clientWidth;
}

export function getElementHeight(selector) {
  const element = document.querySelector(selector);
  return element.clientHeight;
}

export function getOffsetFromBottomOfElementToEndOfViewPort(selector) {
  const element = document.querySelector(selector);
  const domRect = element.getBoundingClientRect();
  return window.innerHeight - domRect.bottom;
}
